
export enum SearchErrorsEnum {
    unknown,
    queryTooLong,
    outsideApiLimit,
    discoverListNotExist
}
